var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1C10.4575 1 9 2.4575 9 4.25C9.17787 8.56168 15.3228 8.56043 15.5 4.24998C15.5 2.4575 14.0425 1 12.25 1ZM13.75 4.5H12.5V5.75C12.5 5.8875 12.3875 6 12.25 6C12.1125 6 12 5.8875 12 5.75V4.5H10.75C10.6125 4.5 10.5 4.3875 10.5 4.25C10.5 4.1125 10.6125 4 10.75 4H12V2.75C12 2.6125 12.1125 2.5 12.25 2.5C12.3875 2.5 12.5 2.6125 12.5 2.75V4H13.75C14.0783 4.00625 14.0784 4.49377 13.75 4.5Z",
    fill: "#636363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0774 11.5725C3.282 11.5036 4.48513 11.0999 4.6599 11.0475C5.7774 10.7 6.5099 10.5 8.2749 10.5H12.1424C12.7599 10.5 13.2774 10.0575 13.3749 9.44L13.5899 7.7525C11.003 8.79465 8.11065 6.51115 8.5349 3.75H2.9124L2.5899 2.555C2.5024 2.2275 2.2049 2 1.8674 2H0.749905C0.423705 2.00237 0.422705 2.49767 0.74993 2.5H1.8674C1.9799 2.5 2.0774 2.575 2.1074 2.685L4.2499 10.6525L2.9199 11.0975C1.86715 11.4638 2.12538 13.0007 3.25743 13H4.2499C3.624 13.7829 4.23658 15.0235 5.24743 15C6.25803 15.0235 6.87103 13.7827 6.2449 13H10.7524C10.125 13.7827 10.7421 15.0235 11.7499 15C13.4004 14.9491 13.4032 12.5518 11.7499 12.5H3.2574C2.6971 12.5082 2.55168 11.7498 3.0774 11.5725Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopItem);
export default __webpack_public_path__ + "static/media/shop_item.09bd3d8485fcd6d29beeb033832b75b8.svg";
export { ForwardRef as ReactComponent };